module.exports = __webpack_public_path__ + "img/el-ic-box.12f4c5e4.svg";